module.exports = __webpack_public_path__ + "img/partner1.99e86d77.png";